export default "__VITE_ASSET__DyVi$sXB__"